<script>
import DataLabel from '@/js/components/common/labels/DataLabel';
import RoleBadge from '@/js/components/user/RoleBadge';

export default {
    name: 'UserLabel',

    functional: true,

    props: {
        user: {type: Object, default: null},
        hideIcon: {type: Boolean},
        prefersNickname: {type: Boolean},
        largeIcon: {type: Boolean},
        showLink: {type: Boolean},
        iconClass: {type: String, default: 'fa fa-fw fa-user-circle'},
        none: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        let children, href, user;

        if (props.user) {
            children = props.user.role
                ? [' ', createElement(RoleBadge, {staticClass: 'ml-1', attrs: {'role': props.user.role}})]
                : null;

            if (props.showLink && parent.$gate.allow('read', 'user', props.user)) {
                href = parent.$toRoute('users.show', {user: props.user.route_id}).toString();
            }

            user = {
                name: props.prefersNickname && props.user.nickname || props.user.name || props.user.nickname,
                deleted_at: props.user.deleted_at,
            };
        }

        const iconClass = props.iconClass + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: user,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: props.none || parent.$t('users.nil'),
            href: href,
        };

        return createElement(DataLabel, data, children);
    },
};
</script>
